import Topbar from "./components/topbar/Topbar";
import Menu from "./components/menu/Menu";
import Intro from "./components/intro/Intro";
import AgentFlow from "./components/agentflow/AgentFlow";
import Portfolio from "./components/portfolio/Portfolio";
import Skills from "./components/skills/Skills";
import Work from "./components/works/Works";
import Contact from "./components/contact/Contact";
import "./app.scss";
import { useState } from "react";

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  return (
    <div className="App" data-theme={darkMode ? "dark" : "light"}>
      <Topbar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        darkMode={darkMode}
        setDarkMode={setDarkMode}
      />
      <Menu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
      <div className="section">
        <Intro />
        <AgentFlow />
        <Portfolio />
        <Skills />
        <Work />
        <Contact />
      </div>
    </div>
  );
}

export default App;
